import { computeABTest, ABTestResult } from "@shared/hooks/useABTest/helpers";

/*
 * Dont want to include all the repository code in the widget's config service.
 */
export const isTrafficSplitEnabled = async (
  name: string,
  venueId: number,
  host: string
) => {
  try {
    const response = await fetch(`${host}/api/public/key-value-params/`);
    const data = await response.json();
    return (
      computeABTest(name, data?.results ?? [], venueId) ===
      ABTestResult.EXPERIMENT
    );
  } catch (error) {
    return false;
  }
};
